import Dialog from "@mui/material/Dialog";
import Paper from "@mui/material/Paper";
import { colors } from "healthex-common/colors";
import styled, { css } from "styled-components";
import { mobilePageMaxWidth } from "./HXMobilePage.styles";
export const DialogPaper = styled(Paper) `
    background-color: ${colors.white_background};

    && {
        // Faux-mobile support
        max-width: ${mobilePageMaxWidth}px;

        // Remove spacing around the dialog so it can grow to fit content as much as possible
        // and so there will be no space between the dialog and bottom
        margin: 0;
        max-height: 100%;

        // We want the dialog to always take full width of the screen
        width: 100%;

        // Align dialog to bottom (relevant only if doesn't fill the full screen)
        align-self: flex-end;

        // Remove bottom border radius as it doesn't make sense if bottom aligned
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }
`;
export const HXMobileSheetDialogEl = styled(Dialog) `
    ${(props) => props.roundedCorners === false &&
    css `
            .MuiDialog-paper {
                border-radius: 0px; // this defaults to 4px
            }
        `}
`;
